import React, { useEffect, useState } from "react";
import logo from "../../images/logo.png";
import AuthButton from "../../Components/AuthButton/AuthButton";
import Input from "../../Components/Input/Input";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ACTIVETAB, postLogin } from "../../Actions/actions";
import Loader from "../../Components/Loader/Loader";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CustomToast from "../../Components/CustomToast/CustomToast";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loader } = useSelector((state) => state.userReducer);
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
      dispatch({
        type: ACTIVETAB,
        payload: "Dashboard",
      });
    }
  }, [token]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });

  useEffect(() => {
    document.title = "Repotal | Login";
    const value = JSON.parse(localStorage.getItem("rememberMe")) || false;
    setRememberMe(value);
  }, []);

  // Email and password validation logic
  const validateForm = () => {
    let valid = true;
    let errors = {};

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      errors.email = "Please enter a valid email address";
      valid = false;
    }

    // Validate password length (e.g., min length of 6 characters)
    if (!password || password.length < 6) {
      errors.password = "Password must be at least 6 characters long";
      valid = false;
    }

    setErrors(errors);
    return valid;
  };

  const handleLogin = (val) => {
    navigate(val);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrors({ ...errors, email: "" });
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrors({ ...errors, password: "" });
  };

  const handleRememberMe = (value) => {
    setRememberMe(value);
    localStorage.setItem("rememberMe", JSON.stringify(value));
  };

  const handleSubmit = () => {
    if (validateForm()) {
      // Dispatch login action only if validation passes
      dispatch(
        postLogin(email, password, (data) => {
          if (
            (data?.loginFor == "Client" && data?.clientData?.paymentStatus == "paid") ||
            data?.loginFor == "Admin" ||
            (data?.loginFor == "Employee" && data?.roleName != "Sales Executive")
          ) {
            navigate("/dashboard");
            dispatch({
              type: ACTIVETAB,
              payload: "Dashboard",
            });
          } else {
            dispatch({
              type: ACTIVETAB,
              payload: "Settings",
            });
            navigate("/settings");
          }
        })
      );
    }
  };

  return (
    <div className="font-public min-h-screen flex flex-col justify-center items-center bg-white">
      <div className="">
        <img src={logo} alt="Repotal Logo" className="w-[250px] h-auto" />
      </div>

      <div className="rounded-lg p-8 w-full max-w-sm">
        <h2 className="text-center text-xl font-bold mb-4">Sign in</h2>

        {/* Email Input */}
        <Input
          float={true}
          label={"Email Address"}
          // placeholder={'Email Address'}
          value={email}
          onChange={handleEmailChange}
          error={errors.email}
        />

        {/* Password Input */}
        <Input
          password={true}
          type={"password"}
          label={"Password"}
          value={password}
          onChange={handlePasswordChange}
          // placeholder={"Password"}
          error={errors.password}
        />

        <div className="w-full flex items-center gap-2 -mt-3">
          <input
            type="checkbox"
            id="rememberMe"
            className="rounded text-[#361D32]"
            checked={rememberMe}
            onChange={() => handleRememberMe(!rememberMe)}
          />
          <label htmlFor="rememberMe" className="">
            Remember Me
          </label>
        </div>

        <div className="flex justify-end mb-6">
          <a
            className="text-sm text-[#361D32]-600 hover:underline text-[black]"
            onClick={() => handleLogin("/forgot-password")}
          >
            Forgot password?
          </a>
        </div>
        {/* {loader ? (
          <Loader />
        ) : ( */}
        <AuthButton className="text-white mr-2" title={"Login"} onClick={handleSubmit} />
        {/* )} */}
        <div className="flex justify-center mb-6">
          <a
            className="text-sm text-[#361D32]-600 hover:underline text-[black]"
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
